import {
  getNode,
  stripHTML,
} from './utils';

import './scss/_togglebuttons.scss';

const template = `
    <div class="tsg-togglebuttons tsg-font-sans">
    </div>
`;

class ToggleButtons {
  constructor(nodeOrSelector, data, cbk) {
    this.container = getNode(nodeOrSelector);
    this.data = data;
    this.cbk = cbk;
    this.setup();
  }

  setup() {
    this.container.innerHTML = template;
    this.elem = this.container.querySelector('.tsg-togglebuttons');

    this.data.forEach((d, i) => {
      const e = document.createElement('div');
      e.classList.add('tsg-togglebutton');
      e.classList.add('tsg-togglebutton--equal'); // maybe this has to be an option
      if (d.active) e.classList.add('tsg-togglebutton--active');
      e.setAttribute('title', stripHTML(d.label));
      e.innerHTML = `<div class="tsg-togglebutton--value">${d.label}</div>`;
      e.addEventListener('click', () => { this.change(i); });
      d.elem = e;
      this.elem.appendChild(e);
    });
  }

  change(i) {
    this.data.forEach((d, j) => {
      d.active = j === i;
      d.elem.classList.toggle('tsg-togglebutton--active', d.active);
    });
    this.cbk(this.data[i].value);
  }
}

export default ToggleButtons;
